module.exports = __webpack_public_path__ + "img/Space_icon.f4b7b449.png";